import React, { useCallback, useState } from "react"

import { Identity, User, OMReference } from "@apptivity-lab/firmament-node-sdk"

import TextInput, { emailValidator, isEmail } from "@components/forms/TextInput"
import AsyncButton from "@components/AsyncButton"

type Props = {
    className?: string,
    disabled?: boolean,
    onSubmit?: (identity: Identity) => void,
    error?: Error
}

const LoginForm: React.FunctionComponent<Props> = ({ className, disabled, error, onSubmit }) => {
    const [identifier, setIdentifier] = useState("")
    const [identifierError, setIdentifierError] = useState<Error>()

    const onFormSubmit = useCallback((event) => {
        event.preventDefault()

        if (!identifier) {
            setIdentifierError(new Error("Email address is required"))
            return
        }

        if (isEmail(identifier)) {
            const identity = new Identity({
                identityType: "email",
                provider: "apptivitylab.com",
                identifier: identifier,
                user: new OMReference(User, User.createPlaceholder())
            })
            onSubmit && onSubmit(identity)
        } else {
            setIdentifierError(new Error("Please enter a valid email address (example: someone@example.com)"))
        }
    }, [identifier, onSubmit])

    return (
        <form id="login-form" className={["login-form", className || ""].join(" ")} onSubmit={onFormSubmit}>
            <TextInput type="email" title="Email Address"
                error={identifierError}
                validator={emailValidator}
                onChange={(text) => setIdentifier(text)} />

            {error && <p className="p-[8px] mt-[32px] text-alert-900 bg-alert-100">{error.message}</p>}

            <AsyncButton type="submit"
                className="mt-[32px] w-full button-primary"
                loading={disabled}>
                Send Magic Link
            </AsyncButton>
        </form>
    )
}

export default LoginForm
